import { Center, Loader, Stack } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';
import { useAnalysis } from '@/api/analyses';
import { errorMessage } from '@/api/errors';
import { EmptyState } from '@/components/EmptyState';
import { usePageTitle } from '@/components/usePageTitle';
import { AnalysisDetail } from '@/features/analyses/AnalysisDetail';
import { InternalComments } from '@/features/staff/InternalComments';

export const Route = createFileRoute('/_staff/staff/analyses/$analysisId')({ component: AnalysisPage });

function AnalysisPage() {
  const { analysisId } = Route.useParams();
  const a = useAnalysis(analysisId);
  usePageTitle(a.data?.name.cs ?? analysisId);
  if (a.isPending)
    return (
      <Center py="xl">
        <Loader color="forest" />
      </Center>
    );
  if (a.isError) return <EmptyState title={errorMessage(a.error)} />;
  return (
    <Stack gap="lg">
      <AnalysisDetail analysis={a.data} />
      <InternalComments subject={analysisId} />
    </Stack>
  );
}
